import {Brick, ErrorFlow, registerBrick, Service} from 'olympe';

export default class KillServiceKillBackend extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} backendTag
     * @param {function()} forwardEvent
     * @param {function(ErrorFlow)} setErrorFlow
     */
    update($, [backendTag], [forwardEvent, setErrorFlow]) {
        Service.publish('killService', ({backendTag: backendTag}))
            .then(() => {
                forwardEvent();
            })
            .catch((e) => {
                setErrorFlow(ErrorFlow.create(`Error while killing the service app ${e}`, 1));
            });
    }
}

registerBrick('01999a6ebe30cedcced9', KillServiceKillBackend);
